import { useSWRConfig } from "swr";
import useErrorToast from "~/contexts/error-toast";
import { useFetcher } from "~/hooks/useFetcher";
import { FILE_BROWSER_API } from "~/lib/fileBrowserApi";

type AccessLevel = "read" | "write";

/** The caller's file grants; a failed first load shows an error toast, and access checks then deny. */
const useFilePermissions = () => {
  const { cache } = useSWRConfig();
  const { showError } = useErrorToast();
  return useFetcher<Record<string, AccessLevel[]>>(`${FILE_BROWSER_API}/permissions`, {
    keepPreviousData: true,
    onError: (_error, key) => {
      // A failed refresh keeps serving the loaded permissions, so nothing is unavailable.
      if (cache.get(key)?.data !== undefined) {
        return;
      }
      // Not persistent: SWR retries, and a persistent toast would outlive a later success.
      showError(
        "Couldn't load your file permissions. Some file actions are unavailable. Reload the page to try again."
      );
    },
  });
};

export default useFilePermissions;
